import React from 'react';
import Layout from '../components/Layout';
import PageHeader from '../components/PageHeader';
import { Scale, AlertCircle, Copyright, ShieldAlert, FileWarning, Globe, Gavel, RefreshCw, Mail } from 'lucide-react';

const TermSection = ({ title, icon: Icon, children, delay }) => (
  <div 
    className="bg-card border border-white/5 p-8 rounded-xl mb-8 hover:border-primary/30 transition-all duration-300"
    data-aos="fade-up"
    data-aos-delay={delay}
  >
    <div className="flex items-center gap-4 mb-6 border-b border-white/5 pb-4">
      <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary">
        <Icon size={20} />
      </div>
      <h3 className="text-xl font-serif font-bold text-foreground">{title}</h3>
    </div>
    <div className="text-muted-foreground leading-relaxed space-y-4">
      {children}
    </div>
  </div>
);

const Terms = () => {
  return (
    <Layout>
      <PageHeader 
        title="Terms & Conditions" 
        subtitle="Usage Guidelines & Legal Framework"
        image="https://images.unsplash.com/photo-1450101499163-c8848c66ca85?q=80&w=2070&auto=format&fit=crop"
      />

      <section className="py-24 bg-background">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="text-center mb-16" data-aos="fade-up">
            <p className="text-lg text-muted-foreground">
              Welcome to TOTO INFRA. Please read these Terms and Conditions carefully before using our website. By accessing or using this site, you agree to be bound by these terms.
            </p>
          </div>

          <TermSection title="1. Acceptance of Terms" icon={Scale} delay="0">
            <p>
              By accessing this website, you confirm that you have read, understood, and agreed to be bound by these Terms & Conditions. If you do not agree with any part of these terms, you must discontinue use of our website immediately.
            </p>
          </TermSection>

          <TermSection title="2. Company Information" icon={Globe} delay="100">
            <p>
              TOTO INFRA is a construction and infrastructure company providing services in steel plants, power plants, piling, and civil construction. This website is intended for informational and communication purposes regarding our services and projects.
            </p>
          </TermSection>

          <TermSection title="3. Website Usage" icon={FileWarning} delay="200">
            <ul className="list-disc pl-5 space-y-2">
              <li>You agree to use this website only for lawful purposes.</li>
              <li>You must not use this website in any way that causes, or may cause, damage to the website or impairment of the availability or accessibility of the website.</li>
              <li>Unauthorized extraction, copying, or modification of data, visuals, or text is strictly prohibited.</li>
            </ul>
          </TermSection>

          <TermSection title="4. Intellectual Property" icon={Copyright} delay="300">
            <p>
              All content included on this website, such as text, graphics, logos, button icons, images, and software, is the property of TOTO INFRA or its content suppliers and is protected by international copyright laws. The compilation of all content on this site is the exclusive property of TOTO INFRA.
            </p>
          </TermSection>

          <TermSection title="5. Limitation of Liability" icon={AlertCircle} delay="400">
            <p>
              TOTO INFRA shall not be liable for any direct, indirect, incidental, special, or consequential damages resulting from the use or inability to use this website. We do not warrant that the website will be uninterrupted or error-free.
            </p>
          </TermSection>

          <TermSection title="6. Project Information" icon={ShieldAlert} delay="500">
            <p>
              All project images, renderings, and technical specifications provided on this website are for representational purposes only and may vary from the actual final product. This website does not constitute a formal offer or contract.
            </p>
          </TermSection>

          <TermSection title="7. Indemnification" icon={Gavel} delay="600">
            <p>
              You agree to indemnify, defend, and hold harmless TOTO INFRA, its officers, directors, employees, agents, and third parties, for any losses, costs, liabilities, and expenses (including reasonable attorney's fees) relating to or arising out of your use of or inability to use the Site or services.
            </p>
          </TermSection>

          <TermSection title="8. Governing Law" icon={Scale} delay="700">
            <p>
              These terms and conditions are governed by and construed in accordance with the laws of India. You irrevocably submit to the exclusive jurisdiction of the courts in that State or location.
            </p>
          </TermSection>

          <TermSection title="9. Changes to Terms" icon={RefreshCw} delay="800">
            <p>
              TOTO INFRA reserves the right, in its sole discretion, to change the Terms under which this website is offered. The most current version of the Terms will supersede all previous versions.
            </p>
          </TermSection>

          <div className="mt-16 pt-16 border-t border-white/10 text-center" data-aos="fade-up">
            <h3 className="text-2xl font-serif font-bold text-foreground mb-6">Contact Information</h3>
            <div className="flex flex-col md:flex-row justify-center gap-8 mt-8">
              <div className="bg-card p-6 rounded-xl border border-white/5">
                <Mail className="w-8 h-8 text-primary mx-auto mb-4" />
                <p className="text-foreground font-bold">Legal Department</p>
                <a href="mailto:sandhya@totoinfra.com" className="text-muted-foreground hover:text-primary transition-colors">sandhya@totoinfra.com</a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Terms;
